import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import {
	ChangedUserStates,
	UserStatesModel,
	UserStatesService
} from '@brand-lolly/app/services/user-states.service';
import { smiUrl } from 'components';
import { Observable, Subject } from 'rxjs';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserStatesHttpService implements OnDestroy {
	private unSubscriber$ = new Subject<void>();

	constructor(
		private userStatesService: UserStatesService,
		private http: HttpClient
	) {}

	public init() {
		this.fetchUserStates()
			.pipe(takeUntil(this.unSubscriber$))
			.subscribe(userStates => {
				this.userStatesService.userStates.next(userStates);
			});

		this.userStatesService.needUpdate
			.pipe(
				takeUntil(this.unSubscriber$),
				filter(value => !!value),
				switchMap(changed => this.changeUserStates(changed))
			)
			.subscribe();
	}

	private fetchUserStates(): Observable<UserStatesModel> {
		const url = smiUrl().add('user-states').done();

		if (!this.userStatesService.hintsDisabled) {
			return this.http.get<UserStatesModel>(url);
		}

		return this.http.get<UserStatesModel>(url).pipe(
			map(value => {
				return { ...value, show_hints: false };
			})
		);
	}

	private changeUserStates(changedUserStates: ChangedUserStates) {
		const url = smiUrl().add('user-states').done();
		return this.http.put<void>(url, changedUserStates);
	}

	ngOnDestroy() {
		this.unSubscriber$.next();
		this.unSubscriber$.complete();
	}
}
